import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdateCategoryForm from '../../forms/CreateOrUpdateCategoryForm'

interface CreateCategoryModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const CreateCategoryModal: React.FC<CreateCategoryModalProps> = ({
  open,
  onClose,
  loading,
  error
}) => (
  <AppModal open={open} onClose={onClose} title="Add Category" width="sm" loading={loading}>
    <CreateOrUpdateCategoryForm loading={loading} error={error} />
  </AppModal>
)
export default CreateCategoryModal
